import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Users, Compass } from "lucide-react";
import ProjectForm from "../components/ProjectForm";

const TRUST = [
  {
    icon: ShieldCheck,
    title: "Confidential intake",
    desc: "Information shared here is used only to qualify and respond to your project.",
  },
  {
    icon: Users,
    title: "Reviewed by partners",
    desc: "Your intake is reviewed by a senior CPS Consulting partner, not a bot.",
  },
  {
    icon: Compass,
    title: "1 business day",
    desc: "We aim to respond to qualified inquiries within one business day.",
  },
];

export default function SubmitProjectPage() {
  return (
    <main className="bg-gradient-to-b from-white via-slate-50 to-white pt-28 pb-24 lg:pt-32">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <Link
          to="/"
          data-testid="submit-back-home"
          className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 hover:text-[#00A3E0]"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back home
        </Link>

        <div className="mt-6 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          {/* Left rail */}
          <div className="lg:col-span-4">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-[#00A3E0]" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-600">
                Submit Your Project
              </span>
            </div>
            <h1 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-slate-900 sm:text-5xl">
              Tell us about <br />
              <span className="text-[#00A3E0]">your ambition.</span>
            </h1>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              A four-step intake based on how CPS Consulting evaluates new
              engagements — designed to give us exactly what we need to come back
              with a meaningful response.
            </p>

            <div className="mt-10 space-y-5">
              {TRUST.map((t) => (
                <div key={t.title} className="flex items-start gap-4">
                  <div className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-[#00A3E0]/10 text-[#00A3E0]">
                    <t.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="font-display text-base font-bold text-slate-900">
                      {t.title}
                    </p>
                    <p className="mt-0.5 text-sm text-slate-600">{t.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-8">
            <ProjectForm />
          </div>
        </div>
      </div>
    </main>
  );
}
